class Logger {
  Error (message, data) {
    console.error(`[Error] ${message} `)
    if (data) {
      console.log(data)
    }
  }

  Trace (message, data) {
    console.log(`[TRACE] ${message} `)
    if (data) {
      console.log(data)
    }
  }
}

export const log = new Logger()
export default log
